<template>
  <div class="payment-page">
    <header class="payment-page__header">
      <h1 class="payment-page__title">{{ $t('withdraw.withdraw_form') }}</h1>
      <p class="payment-page__subtitle">
        {{ $store.state.language === 'en' ? 'Withdraw to your linked bank account' : 'ချိတ်ဆက်ထားသော ဘဏ်အကောင့်သို့ ငွေထုတ်ရန်' }}
      </p>
    </header>

    <section class="payment-panel">
      <div class="payment-panel__accent"></div>
      <div class="payment-panel__body">
        <div v-if="error" class="payment-error-banner">
          {{ error }}
        </div>

        <div class="payment-account-card">
          <button
            type="button"
            class="payment-account-card__edit"
            aria-label="Edit bank account"
            @click="$router.push('/banking')"
          >
            <i class="fas fa-pen" aria-hidden="true"></i>
          </button>
          <span class="payment-account-card__type">{{ bankInfo.type }}</span>
          <span class="payment-account-card__name">{{ bankInfo.name }}</span>
          <h3 class="payment-account-card__number">
            {{ blurLastFiveCharacters(bankInfo.account_number) }}
          </h3>
        </div>

        <form @submit.prevent>
          <div class="payment-field">
            <label class="payment-field__label">{{ $t('withdraw.amount') }}</label>
            <span class="payment-field__hint">{{ $t('withdraw.minimum_deposit') }}</span>
            <input
              type="number"
              class="payment-input"
              v-model="withdrawData.amount"
            />
            <span class="payment-field__error">{{ errors.amount }}</span>
          </div>

          <div class="payment-field">
            <label class="payment-field__label">{{ $t('withdraw.remark') }}</label>
            <textarea
              class="payment-input"
              rows="3"
              v-model="withdrawData.remark"
            />
          </div>

          <button
            type="button"
            class="payment-submit-btn"
            :disabled="isConfirm"
            @click="sendWithdrawData"
          >
            <Loading
              v-if="isConfirm"
              color="#1a1a1a"
              size="24"
            />
            <span v-else>{{ $t('withdraw.submit') }}</span>
          </button>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      bankInfo: {},
      accounts: [],
      account: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
      error: null,
    };
  },
  methods: {
    blurLastFiveCharacters(inputString = '0000000000') {
      const length = inputString.length;

      if (length >= 7) {
        const firstPart = inputString.substring(length - 5, length);
        const blurredCharacters = '*'.repeat(length - 5);
        return blurredCharacters + firstPart;
      }

      return inputString;
    },
    ...mapActions(['fetchUser']),
    async sendWithdrawData() {
      try {
        this.isConfirm = true;
        const authUser = await this.fetchUser();
        this.errors = {};
        this.error = null;

        if (!this.withdrawData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          this.isConfirm = false;
          return false;
        }
        if (this.withdrawData.amount < 10000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 10000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး ၁၀၀၀၀ ထည့်ပေးပါ။';
          this.isConfirm = false;
          return false;
        }
        if (this.withdrawData.amount > parseInt(authUser.amount)) {
          const balanceError = this.$store.state.language === 'en'
            ? "You Don't Have Sufficient Balance"
            : 'အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။';
          Dialog.alert({
            message: balanceError,
            confirmButtonText:
              this.$store.state.language === 'en'
                ? 'Go Back'
                : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isConfirm = false;
          return false;
        }
        this.$store.commit(
          'setAmount',
          (this.$store.state.amount -= this.withdrawData.amount),
        );

        if (this.imageUploader[0]) {
          this.withdrawData.transaction_image = this.imageUploader[0].content;
        }
        this.withdrawData.date = this.currentTime;
        this.withdrawData.account_number = this.bankInfo.account_number;
        this.withdrawData.account_name = this.bankInfo.name;
        this.withdrawData.type = this.bankInfo.type;
        this.withdrawData.lang = localStorage.getItem('language');

        await axios.post('/withdraws', this.withdrawData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        await axios.post(
          `/admin/user/${this.$store.state.authUser.id}`,
          {
            amount: this.withdrawData.amount,
            type: 'withdraw',
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.imageUploader = [];
        this.withdrawData = {};
        this.selected_account.account_id = null;
        await this.fetchUser();
        Toast.success('Success');
        this.isConfirm = false;
      } catch (err) {
        Toast.fail('Fail');
        this.error = err.response?.data || 'Request failed';
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    if (authUser && (!authUser.bank.account_number || !authUser.bank.name)) {
      this.$router.push('/banking');
    }
    this.bankInfo = authUser.bank;
  },
};
</script>
